import type { FC } from 'react';
import type { LineProps } from './index';

export const BoldLine: FC<LineProps> = ({ color }) => {
    return (
        <svg width="88" height="4" viewBox="0 0 88 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 2H88" stroke={color} strokeWidth="4" />
        </svg>
    );
};
